
export function WaitAsync(milliseconds: number) {
    return new Promise((res) => setTimeout(res, milliseconds));
}
